module.exports = __webpack_public_path__ + "static/media/download.2dd51252.svg";